const $ = jQuery;
let transitionDuration = 1000;

export default function () {
    if ($('.js-chat-faq--box').length === 0) return;
    transitionDuration = getTransitionDurationFromCssVariable();

    $('.js-chat-faq--item-title').on('click', handleItemClick);
    $('.js-chat-faq--box-back').on('click', handleCloseAnimation);
}

const getTransitionDurationFromCssVariable = () => {
    const variableValue = $(':root').css('--chat-faq-duration');
    return parseInt(variableValue);
};

let $box = null;
const handleItemClick = (e) => {
    const $item = $(e.currentTarget);
    const index = $item.data('index');
    $box = $item.closest('.js-chat-faq--box');
    const $itemContent = $box.find(`.js-chat-faq--item-content[data-index="${index}"]`);

    $box.toggleClass('is-open');
    handleOpenAnimation($item, $itemContent);
};

const handleCloseAnimation = (e) => {
    $box = $(e.currentTarget).closest('.js-chat-faq--box');

    $box.removeClass('is-open');
    const $currentItem = $box.find('.js-chat-faq--item-title.active');
    const $currentItemContent = $box.find(`.js-chat-faq--item-content[data-index="${$currentItem.data('index')}"]`);
    const halfTransitionDuration = transitionDuration / 2;

    changeCssVariable('--chat-faq-duration', halfTransitionDuration + 'ms');
    moveActiveItemTop($currentItem);
    $currentItem.addClass('is-hidden');
    $currentItemContent.slideToggle(halfTransitionDuration);

    setTimeout(() => {
        $currentItem.css('transition', 'none');
        $currentItem.css('transform', 'translateY(500px)');
        $currentItem[0].offsetHeight; // eslint-disable-line no-unused-expressions
        $currentItem.css('transition', transitionDuration + 'ms');

        $box.find('.js-chat-faq--item-title').each((index, item) => {
            returnToInitialPosition($(item));
        });

        returnCssVariableToInitialValue();
    }, 300);
};

const $contentParentHeight = $('.chat-faq__box-items-content');

const handleOpenAnimation = ($activeItem, $itemContent) => {
    let top = calculateTopFromBox($activeItem);

    if (window.innerWidth < 1024) {
        top = top - 35; // move from top little
    } else {
        top = top - 40;
    }

    // const currentWidth = $activeItem.outerWidth();
    $activeItem.css({
        transform: `translateY(-${top}px)`,
        // width: currentWidth + 'px',
    });

    let itemHeight = $activeItem.outerHeight();
    itemHeight = itemHeight + 16; // add 16px to the height to account for the padding
    $contentParentHeight.css('height', `calc(100% - ${itemHeight}px)`);

    setTimeout(() => {
        hideOtherTitles($activeItem);
        // $activeItem.css('width', currentWidth - 70 + 'px');
        $activeItem.addClass('active');
        $itemContent.slideToggle(transitionDuration);
    }, 100);
};

const hideOtherTitles = ($activeItem) => {
    const $titles = $activeItem.siblings('.js-chat-faq--item-title');
    $titles.addClass('is-hidden');
    $titles.css('transform', 'translateY(500px)');
};

const changeCssVariable = (variable, value) => {
    document.documentElement.style.setProperty(variable, value);
};

const returnCssVariableToInitialValue = () => {
    changeCssVariable('--chat-faq-duration', transitionDuration + 'ms');
};

const calculateTopFromBox = ($item) => {
    const boxTop = $box.offset().top;
    const itemTop = $item.offset().top;
    return itemTop - boxTop;
};

const moveActiveItemTop = ($activeItem) => {
    $activeItem.css('transform', `translateY(-400px)`);
};

const returnToInitialPosition = ($item) => {
    $item.css('position', 'initial');
    $item.css('transform', 'translateY(0)');
    $item.removeClass('is-hidden');
    $item.removeClass('active');
};
